import React, {
  memo, useMemo, useState, 
} from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { arrowDownIcon } from 'assets/images';
import { data } from './data';

import styles from './styles.module.scss';

export const PopularQuestionsContainer = memo(() => {
  const { t } = useTranslation('welcome');
  const [openFAQId, setOpenFAQId] = useState<number | null>(null);

  const handleFAQClick = (id:number) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };

  const questionsCards = useMemo(() => (
    <div className={styles.faq_cards_container}>
      {data.map(({ id, question, answer }, index) => {
        const isOpen = openFAQId === index;

        return (
          <div
            key={id}
            className={styles.each_faq}
          >
            <div className={styles.each_faq_top}>
              <div className={styles.each_faq_top_left}>
                <span>{id}</span>
                <p>{t(question)}</p>
              </div>
              <Button
                onClick={() => handleFAQClick(index)}
              >
                <img
                  alt=""
                  className={`${styles.open_faq_icon} ${isOpen ? styles.rotated : ''}`}
                  src={arrowDownIcon}
                />
              </Button>
            </div>
            <p
              className={`${styles.each_faq_answer} ${isOpen ? styles.each_faq_answer_open : ''}`}
            >
              {t(answer)}
            </p>
          </div>
        );
      })}
    </div>
  ), [openFAQId, t]);

  return (
    <div className={styles.faq_container}>
      <div className={styles.faq_title_container}>
        <p>{t('Popular_title_')}</p>
        <span>{t('Popular_title_part2_')}</span>
      </div>
      {questionsCards}
    </div>
  );
});
